import { render, staticRenderFns } from "./ProductInsightWidget.vue?vue&type=template&id=08a8f4ac&scoped=true"
import script from "./ProductInsightWidget.vue?vue&type=script&lang=js"
export * from "./ProductInsightWidget.vue?vue&type=script&lang=js"
import style0 from "./ProductInsightWidget.vue?vue&type=style&index=0&id=08a8f4ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a8f4ac",
  null
  
)

export default component.exports